import { useEffect } from 'react';
import { useTenantStore, useThemeStore } from '@/app/stores';

/** Maps tenant branding + light/dark mode onto CSS variables / the <html> class. Renders nothing. */
export function ThemeApplier() {
  const tenant = useTenantStore((s) => s.tenant);
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);

  useEffect(() => {
    const root = document.documentElement;
    const t = tenant.theme;
    root.style.setProperty('--primary', t.primaryColor);
    root.style.setProperty('--secondary', t.secondaryColor);
    root.style.setProperty('--accent', t.accentColor);
    root.style.setProperty('--radius', t.borderRadius);
    root.style.setProperty('--font-family', `'${t.fontFamily}'`);
    document.title = tenant.seo.title;
    // Load the merchant's chosen font (allow-listed server-side); falls back to system fonts if offline.
    const id = 'mce-tenant-font';
    let link = document.getElementById(id) as HTMLLinkElement | null;
    if (!link) { link = document.createElement('link'); link.id = id; link.rel = 'stylesheet'; document.head.appendChild(link); }
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(t.fontFamily).replace(/%20/g, '+')}:wght@400;500;600;700;800&display=swap`;
    document.querySelector('meta[name="description"]')?.setAttribute('content', tenant.seo.description);
  }, [tenant]);

  // Tenant default mode applies until the shopper picks one (their choice is persisted); if toggling is disabled it is forced.
  useEffect(() => {
    let chosen = false;
    try { chosen = !!localStorage.getItem('mce.theme.v1'); } catch { /* ignore */ }
    if (tenant.theme.allowModeToggle === false || (!chosen && tenant.theme.defaultMode)) setMode(tenant.theme.defaultMode ?? 'light');
  }, [tenant.theme.defaultMode, tenant.theme.allowModeToggle, setMode]);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', mode === 'dark');
  }, [mode]);

  return null;
}
